import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

interface Message {
  created: string;
  id: number;
  modified: string;
  person: string;
  value: string;
}

@Component({
  selector: 'app-chat-inner',
  templateUrl: './chat-inner.component.html'
})
export class ChatInnerComponent implements OnInit {
  @Input() messages: Observable<Message[]>;
  @Input() isDrawer: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
